import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Github } from "lucide-react";
import { resolveUrl } from "@/lib/api";

export function ProjectCard({ project, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`project-card-${project.slug}`}
      className="h-full"
    >
      <Link to={`/projects/${project.slug}`} className="group block h-full">
        <div className="relative overflow-hidden rounded-3xl glass p-2 hover:-translate-y-1 transition-transform duration-300 h-full flex flex-col">
          <div className="relative h-60 sm:h-72 overflow-hidden rounded-2xl shrink-0">
            <img
              src={resolveUrl(project.cover_image)}
              alt={project.title}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            {project.featured && (
              <span className="absolute top-4 left-4 text-[11px] uppercase tracking-[0.15em] font-medium px-3 py-1 rounded-full bg-white/90 text-zinc-900">
                Featured
              </span>
            )}
            <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
              <div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-white/80 font-mono">{project.category}</div>
                <h3 className="text-white text-xl font-heading font-medium mt-1">{project.title}</h3>
              </div>
              <div className="h-10 w-10 grid place-items-center rounded-full bg-white/90 text-zinc-900 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                <ArrowUpRight className="w-5 h-5" />
              </div>
            </div>
          </div>
          <div className="px-4 py-4 flex-grow flex flex-col justify-between">
            <p className="text-sm text-muted-foreground leading-relaxed line-clamp-2">{project.summary}</p>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {(project.tech_stack || []).slice(0, 4).map((t) => (
                <span key={t} className="text-[11px] font-mono px-2 py-1 rounded-md bg-secondary text-secondary-foreground">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
